import styled from 'styled-components';
export var Wrap = styled.div.withConfig({
  displayName: "style__Wrap",
  componentId: "sc-1f04ibx-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:999;overflow:hidden;background:#dcecee;"]);
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1f04ibx-1"
})(["width:100%;height:100%;display:flex;align-items:center;background:#dcecee;"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "sc-1f04ibx-2"
})(["width:100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:0 auto 3em;height:500px;"]);
export var Panel = styled.div.withConfig({
  displayName: "style__Panel",
  componentId: "sc-1f04ibx-3"
})(["height:400px;width:266px;padding:32px;margin:16px;background:", ";border-radius:10px;cursor:", ";"], function (props) {
  return props.loading ? 'hsla(0, 0%, 100%, 0.7);' : 'white';
}, function (props) {
  return props.loading ? 'wait' : 'auto';
});
export var SectionTitle = styled.div.withConfig({
  displayName: "style__SectionTitle",
  componentId: "sc-1f04ibx-4"
})(["position:relative;background-color:#dcecee;color:", ";top:170px;font-size:1.4em;font-weight:700;width:100%;margin:auto;flex:none;text-align:center;"], function (props) {
  return props.red ? 'red' : 'black';
});
export var Title = styled.div.withConfig({
  displayName: "style__Title",
  componentId: "sc-1f04ibx-5"
})(["font-size:2em;width:100%;margin:0 0 0.25em;padding:0 0 0.5em;border-bottom:2px solid rgba(27,26,28,0.4);text-align:center;"]);
export var Price = styled.div.withConfig({
  displayName: "style__Price",
  componentId: "sc-1f04ibx-6"
})(["color:rgb(48,194,255);font-size:1.75em;padding:1em 0 0.75em;text-align:center;"]);
export var Sentence = styled.div.withConfig({
  displayName: "style__Sentence",
  componentId: "sc-1f04ibx-7"
})(["font-weight:bold;font-size:1em;width:100%;margin:0 0 0.25em;padding:0 0 0.5em;text-align:center;"]);
export var FeatureList = styled.ul.withConfig({
  displayName: "style__FeatureList",
  componentId: "sc-1f04ibx-8"
})(["margin:0;padding:1em 1.25em 2em;"]);
export var Feature = styled.li.withConfig({
  displayName: "style__Feature",
  componentId: "sc-1f04ibx-9"
})(["display:list-item;text-align:-webkit-match-parent;"]);
export var Button = styled.div.withConfig({
  displayName: "style__Button",
  componentId: "sc-1f04ibx-10"
})(["font-weight:bold;font-size:1.3em;margin-top:auto;border-radius:5px;background:rgb(48,194,255);height:40px;line-height:40px;transition:background 0.3s;text-align:center;color:white;cursor:", ";"], function (props) {
  return props.disabled ? 'wait' : 'pointer';
});